import { inject } from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { map, Observable } from 'rxjs';

export const noRightsGuard = (): Observable<boolean> => {
  const permissionsService = inject(UserRolesAndPermissionsService);

  return permissionsService
    .hasPermissions([
      RolesAndPermissions.TripRead,
      RolesAndPermissions.AssetRead,
      RolesAndPermissions.VehicleRead,
      RolesAndPermissions.POIRead,
      RolesAndPermissions.UserRead,
      RolesAndPermissions.ReportRead,
      RolesAndPermissions.SettingsRead,
    ])
    .pipe(map(hasPermissions => !hasPermissions));
};
